<!-- Ported from the Polaris kit: src/components/ui/command/CommandEmpty.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { reactiveOmit } from '@vueuse/core';
import { Primitive } from 'reka-ui';
import { computed } from 'vue';
import { cn } from '../../lib/utils';
import { useCommand } from '.';

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class');

const { filterState } = useCommand();
const isRender = computed(
  () => !!filterState.search && filterState.filtered.count === 0
);
</script>

<template>
  <Primitive
    v-if="isRender"
    data-slot="command-empty"
    v-bind="delegatedProps"
    :class="cn('py-6 text-center type-polaris-body', props.class)"
  >
    <slot />
  </Primitive>
</template>
